import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';

export default function Loader({
    open,
    setOpen,
    message
}) {

    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1000,
                flexDirection: 'column',
                gap: 2
            }}
            open={open}
        // onClick={setO}
        >
            <CircularProgress color="inherit" />
            {message && (
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
                    <span style={{ fontSize: '1.2rem', fontWeight: 500 }}>
                        {message}
                    </span>
                </div>
            )}
        </Backdrop>
    );
}
